import { HttpContextToken } from '@angular/common/http';

export const SKIP_REFRESH_ON_401 = new HttpContextToken<boolean>(() => false);
